/**
 * Merge two maps and pass the `parent` values into the `child` if the don't exists
 * @param {OptionsListMapProps | null} custom
 * @param {OptionsListMapProps} defaults
 * @returns {OptionsListMapProps}
 */
const mergeMaps = (custom, defaults) => {
  if (!custom) {
    return defaults;
  }

  const result = defaults;

  for (let [name, values] of custom) {
    result.set(name, values);
  }

  return result;
};

export default mergeMaps;
